import { BaseLiveConnection, BetStatus } from '@pascal/pascal-core';

import { API } from '../../../core/constants/endpoints';
import { gameService } from '../gameService';
import { DemoGameLiveConnectionMethod } from '../../../enums/DemoGameLiveConnectionMethod';
import { gameStore } from '../../store/gameStore';
import { configStore } from '../../store/configStore';

const isDevelopment = process.env.REACT_APP_ENV === 'development';

export class DemoGameLiveConnection extends BaseLiveConnection {

  constructor() {
    super(`${API}/game`);
  }

  setConnectionListeners() {
    this.connection.on(DemoGameLiveConnectionMethod.GetDemoInitialStateResult, gameService.onGetInitialStateResult);
    this.connection.on(DemoGameLiveConnectionMethod.DemoCashOutResult, gameService.onCashOutResult);
    this.connection.on(DemoGameLiveConnectionMethod.DemoResultReportResult, gameService.onResultReportResult);
    this.connection.on(DemoGameLiveConnectionMethod.DoDemoSpinResult, gameService.onDoSpinResult);
  }

  /**
   * @name sendGetInitialState
   * @returns {void}
   */
  sendGetInitialState() {
    return this.invoke(DemoGameLiveConnectionMethod.GetDemoInitialState, { partnerId: configStore.partnerId });
  }

  /**
   * @name sendDoSpin
   * @returns {void}
   */
  sendDoSpin() {
    return this.invoke(DemoGameLiveConnectionMethod.DoDemoSpin, {
      partnerId: configStore.partnerId,
      currencyCode: 'FUN',
      amount: gameStore.amount,
      matrixType: gameStore.matrixType,
    });
  }

  /**
   * @name sendResultReport
   * @returns {void}
   */
  sendResultReport() {
    return this.invoke(DemoGameLiveConnectionMethod.DemoReportState, gameStore.chosenField);
  }

  /**
   * @name sendCashOut
   * @returns {void}
   */
  sendCashOut() {
    return this.invoke(DemoGameLiveConnectionMethod.DemoCashOut);
  }

}

